import React from "react";
import { useTranslation } from "react-i18next";
import { renderHTML } from "../hooks/htmlToText";

export const TermsIntro = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-5">
      <p>{renderHTML(String(t("termsPage.p1")))}</p>
      <p>{renderHTML(String(t("termsPage.p2")))}</p>
      <p>{renderHTML(String(t("termsPage.p3")))}</p>

      <p>{renderHTML(String(t("termsPage.p4")))}</p>

      <p>{renderHTML(String(t("termsPage.p5")))}</p>
      <p>{renderHTML(String(t("termsPage.p6")))}</p>
      <p>{renderHTML(String(t("termsPage.p7")))}</p>
      <p>{renderHTML(String(t("termsPage.p8")))}</p>
    </div>
  );
};
